import React, {useCallback, useEffect, useState} from 'react';
import classes from './Translate.module.pcss';
import fetchData from './fetchData';
import useFetchData from '../../../../hooks/useFetchData/useFetchData';
import Heading from '../../../Common/Heading/Heading';
import DataValidator from '../../DataValidator/DataValidator';
import {useCookies} from 'react-cookie/cjs';
import {observer} from 'mobx-react';
import SearchStore from '../../../../store/SearchStore';


const TranslateSelector = () => {
    const [cookies, setCookie] = useCookies([]);
    const [infoTitle, setInfoTitle] = useState('');
    const [infoDescription, setDescription] = useState('');
    const [showInfo, setShowInfo] = useState(false);

    const {lang} = SearchStore;

    useFetchData({
        query: `${fetchData}`,
        condition: true,
        updateData: (data) => {
            setInfoTitle(data?.themeGeneralSettings?.Options?.translationDisclaimer?.title);
            setDescription(data?.themeGeneralSettings?.Options?.translationDisclaimer?.description);
        }
    });

    useEffect(() => {
        const script = document.createElement('script');
        script.src = '//translate.google.com/translate_a/element.js';
        script.async = true;
        document.body.appendChild(script);

        const waitForTranslate = () => {
            if (window.google?.translate?.TranslateElement) {
                // eslint-disable-next-line no-new
                new window.google.translate.TranslateElement({
                    pageLanguage: 'en',
                    includedLanguages: 'en,pt,pt-PT,es,fr,it,de,nl,pl,et,cs',
                    layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
                    autoDisplay: true
                }, 'google_translate_element');
            } else {
                setTimeout(waitForTranslate, 100);
            }
        };

        waitForTranslate();
    }, []);

    useEffect(() => {
        const obs = new MutationObserver(() => {
            const newLang = document.cookie
                .split('; ')
                .find(row => row.startsWith('googtrans='))
                ?.split('=')[1];

            if (newLang && !cookies['hideLangInfo']) {
                setShowInfo(true);
            } else {
                setShowInfo(false);
            }

            if (newLang && newLang !== lang) {
                SearchStore.setLang(newLang);
            }
        });

        const target = document.getElementById('google_translate_element');
        if (target) {
            obs.observe(target, { childList: true, subtree: true });
        }

        return () => obs.disconnect();
    }, [cookies, lang]);

    useEffect(() => {
        let timeoutId;

        if (showInfo) {
            clearTimeout(timeoutId);

            timeoutId = setTimeout(() => {
                setCookie('hideLangInfo', 'true', { path: '/', sameSite: 'strict' });
                setShowInfo(false);
            }, 15000);
        }

        return () => {
            clearTimeout(timeoutId);
        };
    }, [setCookie, showInfo]);

    const closeButtonHandler = useCallback(() => {
        setCookie('hideLangInfo', 'true', { path: '/', sameSite: 'strict' });
        setShowInfo(false);
    }, [setCookie]);

    return <>
        <div id="google_translate_element" data-lang={lang} className={classes.GoogleTranslateElement} />
        <DataValidator data={infoTitle?.length > 0 && infoDescription?.length > 0 && showInfo && !cookies['hideLangInfo']}>
            <div className={classes.GoogleTranslateInfo}>
                <Heading text={infoTitle} type={'h6'}/>
                <p>{infoDescription}</p>
                <span onClick={closeButtonHandler} className={classes.Cross} />
            </div>
        </DataValidator>
    </>;
};

export default observer(TranslateSelector);
